<template lang="pug">
    img.preloader(src="@/assets/img/preloader.gif")
</template>

<script>
    export default {
        name: "Preloader"
    }
</script>

<style scoped lang="scss">
    .preloader{
        width: 15rem;
        @include mobile_or_P{
            width: 12rem;
        }
    }
</style>
